module.exports = __webpack_public_path__ + "img/symbol_deleteblack.ec79b87d.png";